import React from 'react';
import ComingSoon from '../components/ComingSoon';

export default function AIInsights() {
  return (
    <ComingSoon
      eyebrow="FLOWQUANT PREMIUM"
      title="AI Insights"
      description="Smart summaries, anomaly detection, and trading insights powered by FlowQuant AI. Get personalized risk alerts, performance summaries, and journaling suggestions built around your workflow."
    />
  );
}